import { FC } from 'react'

import { TaskAffecteeInfoFragment } from 'generated/resources/graphql'

export type StepActionFile = {
  id: string
  filename: string
  // Mirrors DocumentsDocument.contentType, which is nullable in the schema.
  contentType?: string | null
  fileUrl: string
}

export type StepActionContentProps = {
  taskId: string
  // The EmployeeLifecycle::StepAction id — distinct from the inbox task id.
  // Present for every step-action taskable; optional only because the
  // taskable can be undefined while the activity query is in flight.
  stepActionId?: string
  files?: StepActionFile[]
  // The task's affectee — the employee whose record the action reads from and
  // writes to (the new hire). `data_input` prefills and writes the form against
  // this employee regardless of who the assignee is.
  affectee?: TaskAffecteeInfoFragment
  // The StepAction's `configuration` serialized as JSON. `data_input` reads its
  // form_name / group_key / field_names from here.
  configurationJson?: string | null
}

export type StepActionContentComponent = FC<StepActionContentProps>

export type ActionType = 'basic_task' | 'training' | 'upload_document' | 'data_input'

export const parseConfigurationJson = (
  json: string | null | undefined
): Record<string, unknown> | null => {
  if (!json) return null

  try {
    const parsed: unknown = JSON.parse(json)

    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
      const record: Record<string, unknown> = { ...parsed }
      return record
    }

    return null
  } catch {
    return null
  }
}
